import { ColorOptions, TextStyleOptions } from '@df/ui/atomic/atomic-options';
import { NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { CMS_COMPONENT_LISTING_CONFIG } from '../../../component/listing/cms-component-listing.config';
import { NCmsBlogComponentListingV2 } from './cms-blog-component-listing-v2.interface';

export const CMS_BLOG_COMPONENT_LISTING_V2_CONFIG = <Omit<NICmsContentComponent.IMeta<NICmsContentComponent.IComponent>, 'type'>>{
    id: NCmsBlogComponentListingV2.ID,
    name: 'Blog Listing (Variant 2)',
    fields: [
        <NICmsContentField.IToggleField>{
            key: 'hero_posts',
            type: NICmsContentField.EFieldType.toggle,
            title: 'Hero posts style',
            default: true
        },
        <NICmsContentField.ITextField>{
            key: 'heading',
            type: NICmsContentField.EFieldType.text,
            title: 'Heading',
            default: 'The Oliver Bonas Blog'
        },
        <NICmsContentField.IChoiceField>{
            key: 'text_style',
            type: NICmsContentField.EFieldType.choice,
            title: 'Text Style',
            options: TextStyleOptions,
            default: 'h2'
        },
        <NICmsContentField.IChoiceField>{
            key: 'color',
            type: NICmsContentField.EFieldType.choice,
            colorPreview: true,
            title: 'Text Color',
            options: ColorOptions,
            default: ''
        },
        <NICmsContentField.ITextField>{
            key: 'cta_copy',
            type: NICmsContentField.EFieldType.text,
            title: 'CTA copy',
            default: 'Read Now'
        },
        ...CMS_COMPONENT_LISTING_CONFIG.fields
    ]
};
